/**
 * Column definitions for the "Add items to the RMA" table.
 * Lives outside the row-rendering component because the card owns the single table that all
 * fulfillment groups render into, while the section only emits rows for one member order.
 */
import { IColumn } from '../../../components/table/table.types';

export const ORDER_PRODUCT_LIST_SCOPE = 'dashboard-create-rma';

type GetTranslation = (key: string, scope: string, args?: string[]) => string;

export const getOrderProductTableColumns = (getTranslation: GetTranslation, isIPad: boolean): IColumn[] => {
    if (isIPad) {
        return [
            { content: '', width: { value: 16, type: 'px' } },
            { content: getTranslation('IMAGE', ORDER_PRODUCT_LIST_SCOPE), width: { value: 50, type: 'px' } },
            { content: getTranslation('NAME', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.6, type: 'fr' } },
            { content: getTranslation('QUANTITY', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.2, type: 'fr' } },
            { content: getTranslation('PAID_AMOUNT_PERITEM', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.4, type: 'fr' } },
            { content: getTranslation('STATUS', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.3, type: 'fr' } },
            { content: '', width: { value: 80, type: 'px' } },
        ];
    }

    return [
        { content: '', width: { value: 16, type: 'px' } },
        { content: getTranslation('IMAGE', ORDER_PRODUCT_LIST_SCOPE), width: { value: 50, type: 'px' } },
        { content: getTranslation('NAME', ORDER_PRODUCT_LIST_SCOPE), width: { value: 1, type: 'fr' } },
        { content: getTranslation('QUANTITY', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.2, type: 'fr' } },
        { content: getTranslation('PAID_AMOUNT_PERITEM', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.4, type: 'fr' } },
        { content: getTranslation('CATALOG_PRICE', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.3, type: 'fr' } },
        { content: getTranslation('FULFILLMENT_DATE', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.3, type: 'fr' } },
        { content: getTranslation('STATUS', ORDER_PRODUCT_LIST_SCOPE), width: { value: 0.4, type: 'fr' } },
        { content: '', width: { value: 0.5, type: 'fr' } },
    ];
};
